import { render, staticRenderFns } from "./Questionnsquare.vue?vue&type=template&id=5b0fc376&scoped=true&"
import script from "./Questionnsquare.vue?vue&type=script&lang=js&"
export * from "./Questionnsquare.vue?vue&type=script&lang=js&"
import style0 from "./Questionnsquare.vue?vue&type=style&index=0&id=5b0fc376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fc376",
  null
  
)

export default component.exports